import productsTree from "./products-tree";
import partnerProductsTree from "./partner-products-tree";
import getBaskets from "./baskets/get-baskets";
import createBillingProfile from "./billing-profiles/create-billing-profile";
import deleteBillingProfile from "./billing-profiles/delete-billing-profile";
import getBillingProfiles from "./billing-profiles/get-billing-profiles";
import replaceBillingProfileWithExisting from "./billing-profiles/replace-billing-profile-with-existing";
import replaceBillingProfileWithNew from "./billing-profiles/replace-billing-profile-with-new";
import setBillingProfileAsDefault from "./billing-profiles/set-billing-profile-as-default";

export default function initRequests(apiUrl) {
  return {
    productsTree: productsTree(apiUrl),
    partnerProductsTree: partnerProductsTree(apiUrl),
    getBaskets: getBaskets(apiUrl),
    createBillingProfile: createBillingProfile(apiUrl),
    deleteBillingProfile: deleteBillingProfile(apiUrl),
    getBillingProfiles: getBillingProfiles(apiUrl),
    replaceBillingProfileWithExisting:
      replaceBillingProfileWithExisting(apiUrl),
    replaceBillingProfileWithNew: replaceBillingProfileWithNew(apiUrl),
    setBillingProfileAsDefault: setBillingProfileAsDefault(apiUrl),
  };
}
